import { BaseSyntheticEvent } from "react";
import { IoColorWandOutline } from "react-icons/io5";
import TooltipConfig from "../../../../../components/Tooltip";

const EditButton = ({ id }: { id: string }) => {
  function MouseOver(event: BaseSyntheticEvent) {
    event.target.style.cursor = "pointer";
  }

  return (
    <TooltipConfig
      content={["Editar"]}
      children={
        <IoColorWandOutline
          onMouseOver={MouseOver}
          size={23}
          onClick={() => window.open(`/dashboard/edit/${id}`)}
        />
      }
      placement={"bottom"}
      style={true}
    />
  );
};

export default EditButton;
